<template>
  <table class="checkout-products">
    <tr :key="item.name" v-for="item in this.products">
      <td class="thumbnail"><img :src="item.image" /></td>
      <td class="product-name">
        {{ item.name }}<br />
        QTY: {{ item.quantity }}
      </td>
      <td class="price">
        <span v-if="item.originalPrice != item.price" class="discounted-price">
          {{currencySymbol}}{{ (item.quantity * item.priceInSelectedCurrency).toFixed(2) }}<br />
        </span>
        <span>{{currencySymbol}}{{ (item.quantity * item.discountedPriceInSelectedCurrency).toFixed(2) }}</span>
      </td>
    </tr>
    <tr v-if="plan.originalPrice > 0">
      <td class="thumbnail"><img :src="plan.image" /></td>
      <td class="product-name">
        {{ plan.name }}<br />
        QTY: {{ plan.quantity }}
      </td>
      <td class="price">
        <span v-if="plan.originalPrice != plan.price" class="discounted-price">
          {{currencySymbol}}{{ (plan.quantity * plan.priceInSelectedCurrency).toFixed(2) }}<br />
        </span>
        <span>{{currencySymbol}}{{ (plan.quantity * plan.discountedPriceInSelectedCurrency).toFixed(2) }}</span>
      </td>
    </tr>
  </table>
</template>
<script>
export default {
  name: 'CheckoutProducts',
  props: ['plan', 'products', 'currencySymbol']
};
</script>
